import { createAction } from 'redux-actions';

export const loadContacts = createAction('LOAD_CONTACTS');
export const searchContacts = createAction('SEARCH_CONTACTS');
export const sortContacts = createAction('SORT_CONTACTS');
export const paginateContacts = createAction('PAGINATE_CONTACTS');
export const refreshContacts = createAction('REFRESH_CONTACTS');
export const createNewContact = createAction('CREATE_NEW_CONTACT');
export const editingContact = createAction('EDITING_CONTACT');
export const updateContact = createAction('UPDATE_CONTACT');
export const closeContactForm = createAction('CLOSE_CONTACT_FORM');
export const selectRemoveContact = createAction('SELECT_REMOVE_CONTACT');
export const deleteManuallySync = createAction('DELETE_MANUALLY_SYNC');
export const setOpenManuallySync = createAction('SET_OPEN_MANUALLY_SYNC');
export const setOpenDelete = createAction('SET_OPEN_DELETE');
export const removeContact = createAction('REMOVE_CONTACT');
export const deleteContactTemporary = createAction('DELETE_CONTACT_TEMPORARY');
export const setClearContactList = createAction('SET_CLEAR_CLIENT_LIST');
export const setAddContacts = createAction('SET_ADD_CONTACTS');
